import React, { useCallback, useEffect, useState } from "react";
import { toast } from "react-toastify";
import { oneKlicks } from "../../../../../SDK/oneclick";
import { getuserdata } from "../../../../../services/apiService";

const Pharmacies = () => {
    const [loading, setLoading] = useState(false);
    const [savedPharmacies, setSavedPharmacies] = useState([]);
    const [selected, setSelected] = useState([]);

    const fetchSaved = useCallback(async () => {
        try {
            setLoading(true);
            const userId = await getuserdata("id");
            if (!userId) return setSavedPharmacies([]);
            const response = await oneKlicks.read("", "pharmacy_wishlist", { user_id: userId }, "id DESC", {}, {}, []);
            if (response?.success) setSavedPharmacies(response.data || []);
            else setSavedPharmacies([]);
        } catch (e) {
            console.error("fetchSaved pharmacies error", e);
            setSavedPharmacies([]);
        } finally {
            setLoading(false);
        }
    }, []);

    useEffect(() => { fetchSaved(); }, [fetchSaved]);

    const handleRemoveAll = async (e) => {
        e.preventDefault();
        try {
            const userId = await getuserdata("id");
            if (!userId) return toast.error("Please login again");
            const res = await oneKlicks.delete("", "pharmacy_wishlist", { user_id: userId });
            if (res?.success) {
                toast.success("All saved pharmacies removed");
                fetchSaved();
            } else {
                toast.error("Failed to remove pharmacies");
            }
        } catch (e) {
            console.error("remove all pharmacies error", e);
            toast.error("Something went wrong");
        }
    };

    const handleRemoveOne = async (pharmacyId) => {
        try {
            const userId = await getuserdata("id");
            if (!userId) return toast.error("Please login again");
            const res = await oneKlicks.delete("", "pharmacy_wishlist", { user_id: userId, pharmacy_id: pharmacyId });
            if (res?.success) {
                toast.success("Removed from saved");
                fetchSaved();
            } else {
                toast.error("Failed to remove");
            }
        } catch (e) {
            console.error("remove pharmacy error", e);
            toast.error("Something went wrong");
        }
    };

    const toggleSelect = (pharmacyId) => {
        setSelected((prev) => prev.includes(pharmacyId) ? prev.filter(id => id !== pharmacyId) : [...prev, pharmacyId]);
    };

    const handleRemoveSelected = async () => {
        if (selected.length === 0) return toast.info("No pharmacies selected");
        try {
            const userId = await getuserdata("id");
            if (!userId) return toast.error("Please login again");
            await Promise.all(selected.map(pid => oneKlicks.delete("", "pharmacy_wishlist", { user_id: userId, pharmacy_id: pid })));
            toast.success("Selected pharmacies removed");
            setSelected([]);
            fetchSaved();
        } catch (e) {
            console.error("remove selected pharmacies error", e);
            toast.error("Failed to remove selected");
        }
    };

    return (
        <div className="dc-tabscontent tab-content">
            <div className="dc-hospsettinghold tab-pane active fade show" id="dc-security">
                <div className="dc-hospsettings dc-tabsinfo dc-tabsinfo-mt">
                    <div className="dc-tabscontenttitle dc-titlewithicon">
                        <h3>Saved Pharmacies</h3>
                        <a href="#" onClick={handleRemoveAll} className="dc-clicksave dc-clickremoveall">
                            <i className="lnr lnr-cross"></i>
                            Remove all saved pharmacies
                        </a>
                    </div>
                    <div className="dc-docsettingscontent dc-sidepadding">
                        {loading ? (
                            <em>Loading...</em>
                        ) : (
                            <div className="dc-searchresult-grid dc-searchresult-list dc-searchvlistvtwo">
                                {savedPharmacies.length === 0 ? (
                                    <div className="dc-emptydata-holder">
                                        <div className="dc-emptydata">
                                            <div className="dc-emptydetails dc-empty-saved-hospitals">
                                                <span></span>
                                                <em>No saved pharmacies yet.</em>
                                            </div>
                                        </div>
                                    </div>
                                ) : (
                                    savedPharmacies.map((item) => (
                                        <div className="dc-docpostholder" key={item.id}>
                                            <div className="dc-docpostcontent">
                                                <div className="dc-searchvtwo">
                                                    <figure className="dc-docpostimg">
                                                        {/* Render pharmacy photo if available */}
                                                        <img width="" height="" className="dc-image-res" src={(Array.isArray(item.photos) ? item.photos[0] : undefined) || "https://via.placeholder.com/100x100"} alt={item.name || "Pharmacy"} />
                                                    </figure>
                                                    <div className="dc-title">
                                                        <h3>
                                                            <a href="#">{item.name || "Pharmacy"}</a>
                                                        </h3>
                                                        <ul className="dc-docinfo">
                                                            <li><em>{item.address || item.formatted_address || ""}</em></li>
                                                        </ul>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="dc-actions">
                                                <label style={{ marginRight: 10 }}>
                                                    <input type="checkbox" checked={selected.includes(item.pharmacy_id)} onChange={() => toggleSelect(item.pharmacy_id)} />
                                                </label>
                                                <a href="#" onClick={(e) => { e.preventDefault(); handleRemoveOne(item.pharmacy_id); }} className="dc-removesingle_saved">
                                                    <span className="lnr lnr-trash"></span>
                                                </a>
                                            </div>
                                        </div>
                                    ))
                                )}
                            </div>
                        )}
                        {savedPharmacies.length > 0 && (
                            <div style={{ marginTop: 10 }}>
                                <button className="dc-alertbtn warning" onClick={(e) => { e.preventDefault(); handleRemoveSelected(); }}>
                                    Remove selected
                                </button>
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </div>
    );
};

export default Pharmacies;


